export enum EntryDoorPanelStyle {
  None = 'none',
  NotRaised = 'not-raised',
  Raised = 'raised',
  Window = 'window', // added for garage door.
}
